import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { useAuthStore } from './stores/auth-store';
import { AppAlertDialog } from './components/ui/AppAlertDialog';
import { DashboardPage } from './pages/DashboardPage';
import { EditorPage } from './pages/EditorPage';
import { useEffect } from 'react';
import { useProjectsStore } from './stores/projects-store';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuthStore();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1e1e2e] flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#89b4fa]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function AuthedApp() {
  const user = useAuthStore((s) => s.user);
  const loadProjects = useProjectsStore((s) => s.loadProjects);

  useEffect(() => {
    if (!user) return;
    const unsubscribe = loadProjects(user.uid);
    return unsubscribe;
  }, [user?.uid, loadProjects]);

  return <Outlet />;
}

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AuthedApp />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="editor/:projectId" element={<EditorPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <AppAlertDialog />
    </>
  );
}
